(function(){
  window.addEventListener('message', function(e){
    if (!/(^|\.)loox\.io$/.test((e.origin||'').replace(/^https?:\/\//,''))) return;
    var d = e.data; try { if (typeof d === 'string') d = JSON.parse(d); } catch(x) { return; }
    if (!d || d.type !== 'resize' || !d.height) return;
    var f = d.frame && document.getElementById(d.frame);
    var list = f ? [f] : [].slice.call(document.querySelectorAll('iframe[src*="loox.io"]')).filter(function(i){ return i.contentWindow === e.source; });
    /* o widget manda alturas intermediarias (2680 -> 2831): aplica so a assentada */
    list.forEach(function(i){
      clearTimeout(i.__clT); var h = d.height;
      i.__clT = setTimeout(function(){ i.style.height = h + 'px'; }, 700);
    });
  });
})();